import { render, staticRenderFns } from "./WPCalculationResult.vue?vue&type=template&id=adb3a156"
import script from "./WPCalculationResult.vue?vue&type=script&lang=ts"
export * from "./WPCalculationResult.vue?vue&type=script&lang=ts"
import style0 from "./WPCalculationResult.vue?vue&type=style&index=0&id=adb3a156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports